import { decode as decodeHtml } from "he";
import { api } from "./client";

const withDecodedName = (item) => {
  if (item && typeof item === "object" && typeof item.Name === "string") {
    return { ...item, Name: decodeHtml(item.Name) };
  }
  return item;
};

export const getPaymentMethods = async (accountNumber) => {
  try {
    if (!accountNumber) return [];
    const url = `accounts/${accountNumber}/paymentMethods`;
    const response = await api.get(url);

    const paymentMethods = Array.isArray(response.data)
      ? response.data.map(withDecodedName)
      : withDecodedName(response.data);

    return paymentMethods;
  } catch (error) {
    console.error("Error fetching payment methods:", error);
    throw error;
  }
};
